const isLockedToAgents = (model) => {
  if (!model) {
    return true;
  }
  const { is_locked_to_agents } = model || {};

  return is_locked_to_agents;
};

export { isLockedToAgents };
